export const queryKeys = {
	productsRootKey: ['products'] as const,
	fishNamesList: ['fishNamesList'] as const,
	fishCutTypesList: ['fishCutTypesList'] as const,
	docList: ['docList'] as const,
	countries: ['countries'] as const,
	fishingAreas: ['fishingAreas'] as const,
	listProductsInManagement: ['products-list-in-management'] as const,
	listProductsInWarehouse: ['products-list-in-warehouses'] as const,
	oneProductInWarehouse: ['one-product-in-warehouse'] as const,
	productInManagement: ['product-in-management'] as const,
	salesStatistic: ['sales-statistic'] as const,
	salesStatisticDetail: ['sales-statistic-detail'] as const,
	userWarehouses: ['user-warehouses'] as const,
	storageAnalytics: ['storage-analytics'] as const,
	storageTopProducts: ['storage-top-products'] as const,
	personalAccount: ['personal-account'] as const,
	personalAccountOfficeStatistic: ['personal-account-office-statistic'] as const,
	platformStatistic: ['platform-statistic'] as const,
	newsSections: ['news-sections'] as const,
	companyEmployees: ['company-employees'] as const,
	tutorialInfo: ['tutorial-info'] as const,
	companyEmployee: ['company-employee'] as const,
	supplier: ['supplier'] as const,
	balance: ['balance'] as const,
	counterparties: ['counterparties'] as const,
	counterparty: ['counterparty'] as const,
	counterpartyDeals: ['counterparty-deals'] as const,
	counterpartyDocuments: ['counterparty-documents'] as const,
	notificationCatalog: ['notification-catalog'] as const,
	crmBoard: ['crm-board'] as const,
	eventTypes: ['event-types'] as const,
};
